// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"838":"ba451e863299d813","883":"b467c68b76416fea","3381":"9e09462d79cac8eb","4106":"6d10c70c6882c28d"}[chunkId] + ".css";
};